import { Container, Grid, Text, Link } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

function CloseAccountSuccess({ state }) {
  const { accountInfo } = state;

  return (
    <Grid rowsGap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="break" size="92" />
      <Text>
        We’ll send you an email to update you on the status of your request.
        <br />
        You can also check back here to see the status of your request.
      </Text>
      <Container>
        <Link appearance="primary-button" href="/manage-account" newTab={false}>
          Manage account
        </Link>
      </Container>
    </Grid>
  );
}

export { CloseAccountSuccess };
